import React from 'react';
import "../components/Hero.css"
import SpaceVd from "../assets/space.mp4"
import { Link

} from 'react-router-dom';
const Hero = () => {
    return (
        <div className='Hero'>
            <video autoPlay loop muted id='video' >
                <source src={SpaceVd} type='video/mp4' />
            </video>
            <div className='Content'>
                <div>
                <h1>Galaxy Travel.</h1>
                <p>World's first civilian space travel .</p>
                </div>
                <div>
                <Link to='/training' className='btn'>Training</Link>
                <Link to='/contact' className='btn btn-light'>Lunch</Link>
            </div>
            </div>
            
        </div>
    );
}

export default Hero;
